import { useState } from 'react';
import { Step } from './types';
import useScavenger from './useScavenger';
import { updateScavenger } from '../firebase/utils/scavenger';

type Status = 'None' | 'Loading' | 'Success' | 'Error';

interface Output {
  setStep: (newStep: Step) => Promise<void>;
  status: Status;
}

const useSetStep = (): Output => {
  const [status, setStatus] = useState<Status>('None');
  const data = useScavenger();

  const currentStep = data.currentStep;

  const setStep = async (newStep: Step) => {
    setStatus('Loading');

    const promise = updateScavenger(data, newStep);

    try {
      const res = await promise;
      setStatus('Success');
    } catch (e) {
      setStatus('Error');
      return Promise.reject();
    }
  };

  return {
    status,
    setStep,
  };
};

export default useSetStep;
